import React from 'react';

const variants = {
  success: 'bg-emerald-500/20 text-emerald-300 ring-emerald-400/30',
  warning: 'bg-amber-500/20 text-amber-300 ring-amber-400/30',
  error: 'bg-red-500/20 text-red-300 ring-red-400/30',
  info: 'bg-sky-500/20 text-sky-300 ring-sky-400/30',
  neutral: 'bg-white/10 text-[#d8d2c5] ring-white/20',
  primary: 'bg-emerald-500 text-white ring-emerald-400/30',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

const Badge = ({ children, variant = 'neutral', size = 'md', dot = false, className = '' }) => {
  const baseClasses =
    'inline-flex items-center gap-1.5 font-semibold rounded-full ring-1 ring-inset';
  const variantClasses = variants[variant] || variants.neutral;
  const sizeClasses = sizes[size] || sizes.md;

  return (
    <span className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
};

export default Badge;
